// The landing page now shares the one shell (left rail on desktop, header +
// drawer on phones). Kept as a named module so App.js imports stay put.
import Layout from './Layout';

export default Layout;
